var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconReset = function SvgIconReset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    fillRule: "evenodd",
    d: "M7 3.65c-.57 0-1.088.091-1.56.233a.437.437 0 1 1-.251-.839A6.3 6.3 0 0 1 7 2.775a5.494 5.494 0 0 1 5.495 5.495A5.494 5.494 0 0 1 7 13.765a5.494 5.494 0 0 1-4.57-8.55.437.437 0 1 1 .728.486 4.6 4.6 0 0 0-.778 2.57A4.62 4.62 0 0 0 7 12.89a4.62 4.62 0 0 0 4.62-4.62A4.62 4.62 0 0 0 7 3.65",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    fillRule: "evenodd",
    d: "M6.564 1.337a.44.44 0 0 1 .043.617L4.92 3.891a.437.437 0 1 1-.66-.575L5.947 1.38a.44.44 0 0 1 .617-.043",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    fillRule: "evenodd",
    d: "M4.237 3.345a.437.437 0 0 1 .612-.095l1.966 1.435a.438.438 0 0 1-.516.707L4.333 3.957a.44.44 0 0 1-.096-.612",
    clipRule: "evenodd"
  })));
};
export default SvgIconReset;